var map = {
	"./activities-image-1.png": "./src/assets/image/template/activities-image-1.png",
	"./activities-image-2.png": "./src/assets/image/template/activities-image-2.png",
	"./activities-image-3.png": "./src/assets/image/template/activities-image-3.png",
	"./activities-image-4.png": "./src/assets/image/template/activities-image-4.png",
	"./activities-image-5.png": "./src/assets/image/template/activities-image-5.png",
	"./activities-image-6.png": "./src/assets/image/template/activities-image-6.png",
	"./activityLevel-image-1.png": "./src/assets/image/template/activityLevel-image-1.png",
	"./activityLevel-image-2.png": "./src/assets/image/template/activityLevel-image-2.png",
	"./activityLevel-image-3.png": "./src/assets/image/template/activityLevel-image-3.png",
	"./activityLevel-image-4.png": "./src/assets/image/template/activityLevel-image-4.png",
	"./age-image-1.png": "./src/assets/image/template/age-image-1.png",
	"./age-image-1.webp": "./src/assets/image/template/age-image-1.webp",
	"./age-image-2.png": "./src/assets/image/template/age-image-2.png",
	"./age-image-2.webp": "./src/assets/image/template/age-image-2.webp",
	"./age-image-3.png": "./src/assets/image/template/age-image-3.png",
	"./age-image-3.webp": "./src/assets/image/template/age-image-3.webp",
	"./age-image-4.png": "./src/assets/image/template/age-image-4.png",
	"./age-image-4.webp": "./src/assets/image/template/age-image-4.webp",
	"./age_group_1_1.webp": "./src/assets/image/template/age_group_1_1.webp",
	"./age_group_1_2.webp": "./src/assets/image/template/age_group_1_2.webp",
	"./age_group_1_3.webp": "./src/assets/image/template/age_group_1_3.webp",
	"./age_group_1_4.webp": "./src/assets/image/template/age_group_1_4.webp",
	"./age_group_2_1.webp": "./src/assets/image/template/age_group_2_1.webp",
	"./age_group_2_2.webp": "./src/assets/image/template/age_group_2_2.webp",
	"./age_group_2_3.webp": "./src/assets/image/template/age_group_2_3.webp",
	"./age_group_2_4.webp": "./src/assets/image/template/age_group_2_4.webp",
	"./age_group_3_1.webp": "./src/assets/image/template/age_group_3_1.webp",
	"./age_group_3_2.webp": "./src/assets/image/template/age_group_3_2.webp",
	"./age_group_3_3.webp": "./src/assets/image/template/age_group_3_3.webp",
	"./age_group_3_4.webp": "./src/assets/image/template/age_group_3_4.webp",
	"./bodyCondition-image-1.png": "./src/assets/image/template/bodyCondition-image-1.png",
	"./bodyCondition-image-2.png": "./src/assets/image/template/bodyCondition-image-2.png",
	"./bodyCondition-image-3.png": "./src/assets/image/template/bodyCondition-image-3.png",
	"./bodyCondition-image-4.png": "./src/assets/image/template/bodyCondition-image-4.png",
	"./bodyCondition-image-5.png": "./src/assets/image/template/bodyCondition-image-5.png",
	"./bodyCondition-image-6.png": "./src/assets/image/template/bodyCondition-image-6.png",
	"./bodyCondition-image-7.png": "./src/assets/image/template/bodyCondition-image-7.png",
	"./bodyShape-1.png": "./src/assets/image/template/bodyShape-1.png",
	"./bodyShape-2.png": "./src/assets/image/template/bodyShape-2.png",
	"./bodyShape-3.png": "./src/assets/image/template/bodyShape-3.png",
	"./bodyShape-4.png": "./src/assets/image/template/bodyShape-4.png",
	"./bodyShape-5.png": "./src/assets/image/template/bodyShape-5.png",
	"./body_fat1.png": "./src/assets/image/template/body_fat1.png",
	"./body_fat2.png": "./src/assets/image/template/body_fat2.png",
	"./brainFog-image-1.png": "./src/assets/image/template/brainFog-image-1.png",
	"./brainFog-image-2.png": "./src/assets/image/template/brainFog-image-2.png",
	"./brainFog-image-3.png": "./src/assets/image/template/brainFog-image-3.png",
	"./brainFog-image-4.png": "./src/assets/image/template/brainFog-image-4.png",
	"./brainFogScreen-image-1.png": "./src/assets/image/template/brainFogScreen-image-1.png",
	"./brainFogScreen-image-2.png": "./src/assets/image/template/brainFogScreen-image-2.png",
	"./brainFogScreen-image-3.png": "./src/assets/image/template/brainFogScreen-image-3.png",
	"./brainFogScreen-image-4.png": "./src/assets/image/template/brainFogScreen-image-4.png",
	"./breathCondition-image-1.png": "./src/assets/image/template/breathCondition-image-1.png",
	"./breathCondition-image-2.png": "./src/assets/image/template/breathCondition-image-2.png",
	"./breathCondition-image-3.png": "./src/assets/image/template/breathCondition-image-3.png",
	"./breathCondition-image-4.png": "./src/assets/image/template/breathCondition-image-4.png",
	"./currentBody-image-1.png": "./src/assets/image/template/currentBody-image-1.png",
	"./currentBody-image-2.png": "./src/assets/image/template/currentBody-image-2.png",
	"./currentBody-image-3.png": "./src/assets/image/template/currentBody-image-3.png",
	"./currentBody-image-4.png": "./src/assets/image/template/currentBody-image-4.png",
	"./currentBody-image-5.png": "./src/assets/image/template/currentBody-image-5.png",
	"./currentBody-image-6.png": "./src/assets/image/template/currentBody-image-6.png",
	"./dietScreen-image-1.png": "./src/assets/image/template/dietScreen-image-1.png",
	"./dietScreen-image-2.png": "./src/assets/image/template/dietScreen-image-2.png",
	"./dietScreen-image-3.png": "./src/assets/image/template/dietScreen-image-3.png",
	"./dietScreen-image-4.png": "./src/assets/image/template/dietScreen-image-4.png",
	"./dietScreen-image-5.png": "./src/assets/image/template/dietScreen-image-5.png",
	"./energyLevel-image-1.png": "./src/assets/image/template/energyLevel-image-1.png",
	"./energyLevel-image-2.png": "./src/assets/image/template/energyLevel-image-2.png",
	"./energyLevel-image-3.png": "./src/assets/image/template/energyLevel-image-3.png",
	"./energyLevel-image-4.png": "./src/assets/image/template/energyLevel-image-4.png",
	"./event-image-1.png": "./src/assets/image/template/event-image-1.png",
	"./event-image-2.png": "./src/assets/image/template/event-image-2.png",
	"./event-image-3.png": "./src/assets/image/template/event-image-3.png",
	"./event-image-4.png": "./src/assets/image/template/event-image-4.png",
	"./event-image-5.png": "./src/assets/image/template/event-image-5.png",
	"./event-image-6.png": "./src/assets/image/template/event-image-6.png",
	"./event-image-7.png": "./src/assets/image/template/event-image-7.png",
	"./event-image-8.png": "./src/assets/image/template/event-image-8.png",
	"./eventScreen-image-1.png": "./src/assets/image/template/eventScreen-image-1.png",
	"./eventScreen-image-2.png": "./src/assets/image/template/eventScreen-image-2.png",
	"./eventScreen-image-3.png": "./src/assets/image/template/eventScreen-image-3.png",
	"./eventScreen-image-4.png": "./src/assets/image/template/eventScreen-image-4.png",
	"./eventScreen-image-5.png": "./src/assets/image/template/eventScreen-image-5.png",
	"./eventScreen-image-6.png": "./src/assets/image/template/eventScreen-image-6.png",
	"./eventScreen-image-7.png": "./src/assets/image/template/eventScreen-image-7.png",
	"./eventScreen-image-8.png": "./src/assets/image/template/eventScreen-image-8.png",
	"./exerciseFrequency-image-1.png": "./src/assets/image/template/exerciseFrequency-image-1.png",
	"./exerciseFrequency-image-2.png": "./src/assets/image/template/exerciseFrequency-image-2.png",
	"./exerciseFrequency-image-3.png": "./src/assets/image/template/exerciseFrequency-image-3.png",
	"./exerciseFrequency-image-4.png": "./src/assets/image/template/exerciseFrequency-image-4.png",
	"./familiarity-image-1.png": "./src/assets/image/template/familiarity-image-1.png",
	"./familiarity-image-2.png": "./src/assets/image/template/familiarity-image-2.png",
	"./familiarity-image-3.png": "./src/assets/image/template/familiarity-image-3.png",
	"./familiarity-image-4.png": "./src/assets/image/template/familiarity-image-4.png",
	"./feelBad-image-1.png": "./src/assets/image/template/feelBad-image-1.png",
	"./feelBad-image-2.png": "./src/assets/image/template/feelBad-image-2.png",
	"./feelBad-image-3.png": "./src/assets/image/template/feelBad-image-3.png",
	"./feelBad-image-4.png": "./src/assets/image/template/feelBad-image-4.png",
	"./feelBadScreen-image-1.png": "./src/assets/image/template/feelBadScreen-image-1.png",
	"./feelBadScreen-image-2.png": "./src/assets/image/template/feelBadScreen-image-2.png",
	"./feelBadScreen-image-3.png": "./src/assets/image/template/feelBadScreen-image-3.png",
	"./feelBadScreen-image-4.png": "./src/assets/image/template/feelBadScreen-image-4.png",
	"./fitness-image-1.png": "./src/assets/image/template/fitness-image-1.png",
	"./fitness-image-2.png": "./src/assets/image/template/fitness-image-2.png",
	"./fitness-image-3.png": "./src/assets/image/template/fitness-image-3.png",
	"./flexibilty-image-1.png": "./src/assets/image/template/flexibilty-image-1.png",
	"./flexibilty-image-2.png": "./src/assets/image/template/flexibilty-image-2.png",
	"./flexibilty-image-3.png": "./src/assets/image/template/flexibilty-image-3.png",
	"./focus-image-1.png": "./src/assets/image/template/focus-image-1.png",
	"./focus-image-2.png": "./src/assets/image/template/focus-image-2.png",
	"./focus-image-3.png": "./src/assets/image/template/focus-image-3.png",
	"./focus-image-4.png": "./src/assets/image/template/focus-image-4.png",
	"./focus-image-5.png": "./src/assets/image/template/focus-image-5.png",
	"./generationScreen-image.png": "./src/assets/image/template/generationScreen-image.png",
	"./happybody-image-1.png": "./src/assets/image/template/happybody-image-1.png",
	"./happybody-image-2.png": "./src/assets/image/template/happybody-image-2.png",
	"./happybody-image-3.png": "./src/assets/image/template/happybody-image-3.png",
	"./happybody-image-4.png": "./src/assets/image/template/happybody-image-4.png",
	"./happybody-image-5.png": "./src/assets/image/template/happybody-image-5.png",
	"./icon_star_light.png": "./src/assets/image/template/icon_star_light.png",
	"./img_video_first.png": "./src/assets/image/template/img_video_first.png",
	"./intro-image-1.png": "./src/assets/image/template/intro-image-1.png",
	"./intro-image-2.png": "./src/assets/image/template/intro-image-2.png",
	"./intro-image-3.png": "./src/assets/image/template/intro-image-3.png",
	"./intro-image-4.png": "./src/assets/image/template/intro-image-4.png",
	"./intro-image-5.png": "./src/assets/image/template/intro-image-5.png",
	"./intro-image-6.png": "./src/assets/image/template/intro-image-6.png",
	"./intro-image-7.png": "./src/assets/image/template/intro-image-7.png",
	"./intro-image-8.png": "./src/assets/image/template/intro-image-8.png",
	"./normal.png": "./src/assets/image/template/normal.png",
	"./normal1.png": "./src/assets/image/template/normal1.png",
	"./normal2.png": "./src/assets/image/template/normal2.png",
	"./obese.png": "./src/assets/image/template/obese.png",
	"./obese1.png": "./src/assets/image/template/obese1.png",
	"./obese2.png": "./src/assets/image/template/obese2.png",
	"./overweight.png": "./src/assets/image/template/overweight.png",
	"./overweight1.png": "./src/assets/image/template/overweight1.png",
	"./overweight2.png": "./src/assets/image/template/overweight2.png",
	"./painful-image-1.png": "./src/assets/image/template/painful-image-1.png",
	"./painful-image-2.png": "./src/assets/image/template/painful-image-2.png",
	"./painful-image-3.png": "./src/assets/image/template/painful-image-3.png",
	"./painful-image-4.png": "./src/assets/image/template/painful-image-4.png",
	"./painful-image-5.png": "./src/assets/image/template/painful-image-5.png",
	"./painful-image-6.png": "./src/assets/image/template/painful-image-6.png",
	"./painful-image-7.png": "./src/assets/image/template/painful-image-7.png",
	"./positive-image-1.png": "./src/assets/image/template/positive-image-1.png",
	"./positive-image-2.png": "./src/assets/image/template/positive-image-2.png",
	"./positive-image-3.png": "./src/assets/image/template/positive-image-3.png",
	"./positive-image-4.png": "./src/assets/image/template/positive-image-4.png",
	"./positive-image-5.png": "./src/assets/image/template/positive-image-5.png",
	"./positive-image-6.png": "./src/assets/image/template/positive-image-6.png",
	"./positive-image-7.png": "./src/assets/image/template/positive-image-7.png",
	"./positive-image-8.png": "./src/assets/image/template/positive-image-8.png",
	"./purpose-image-1.png": "./src/assets/image/template/purpose-image-1.png",
	"./purpose-image-2.png": "./src/assets/image/template/purpose-image-2.png",
	"./purpose-image-3.png": "./src/assets/image/template/purpose-image-3.png",
	"./purpose-image-4.png": "./src/assets/image/template/purpose-image-4.png",
	"./purpose-image-5.png": "./src/assets/image/template/purpose-image-5.png",
	"./sleepHourScreen-image.png": "./src/assets/image/template/sleepHourScreen-image.png",
	"./somatic-image-1.png": "./src/assets/image/template/somatic-image-1.png",
	"./somatic-image-2.png": "./src/assets/image/template/somatic-image-2.png",
	"./somatic-image-3.png": "./src/assets/image/template/somatic-image-3.png",
	"./specialNeed-image-1.png": "./src/assets/image/template/specialNeed-image-1.png",
	"./specialNeed-image-2.png": "./src/assets/image/template/specialNeed-image-2.png",
	"./specialNeed-image-3.png": "./src/assets/image/template/specialNeed-image-3.png",
	"./specialNeed-image-4.png": "./src/assets/image/template/specialNeed-image-4.png",
	"./specialNeed-image-5.png": "./src/assets/image/template/specialNeed-image-5.png",
	"./targetBody-image-1.png": "./src/assets/image/template/targetBody-image-1.png",
	"./targetBody-image-2.png": "./src/assets/image/template/targetBody-image-2.png",
	"./targetBody-image-3.png": "./src/assets/image/template/targetBody-image-3.png",
	"./targetBody-image-4.png": "./src/assets/image/template/targetBody-image-4.png",
	"./transition-mainimage-1.png": "./src/assets/image/template/transition-mainimage-1.png",
	"./transition-mainimage-2.png": "./src/assets/image/template/transition-mainimage-2.png",
	"./transition-mainimage-3.png": "./src/assets/image/template/transition-mainimage-3.png",
	"./typical-image-1.png": "./src/assets/image/template/typical-image-1.png",
	"./typical-image-2.png": "./src/assets/image/template/typical-image-2.png",
	"./typical-image-3.png": "./src/assets/image/template/typical-image-3.png",
	"./typicalDay-image-1.png": "./src/assets/image/template/typicalDay-image-1.png",
	"./typicalDay-image-2.png": "./src/assets/image/template/typicalDay-image-2.png",
	"./typicalDay-image-3.png": "./src/assets/image/template/typicalDay-image-3.png",
	"./underweight.png": "./src/assets/image/template/underweight.png",
	"./underweight1.png": "./src/assets/image/template/underweight1.png",
	"./underweight2.png": "./src/assets/image/template/underweight2.png",
	"./waterDrinkScreen-image-1.png": "./src/assets/image/template/waterDrinkScreen-image-1.png",
	"./waterDrinkScreen-image-2.png": "./src/assets/image/template/waterDrinkScreen-image-2.png",
	"./waterDrinkScreen-image-3.png": "./src/assets/image/template/waterDrinkScreen-image-3.png",
	"./waterDrinkScreen-image-4.png": "./src/assets/image/template/waterDrinkScreen-image-4.png",
	"./weight1.png": "./src/assets/image/template/weight1.png",
	"./weight2.png": "./src/assets/image/template/weight2.png",
	"./weight3.png": "./src/assets/image/template/weight3.png",
	"./workSchedule-image-1.png": "./src/assets/image/template/workSchedule-image-1.png",
	"./workSchedule-image-2.png": "./src/assets/image/template/workSchedule-image-2.png",
	"./workSchedule-image-3.png": "./src/assets/image/template/workSchedule-image-3.png",
	"./workSchedule-image-4.png": "./src/assets/image/template/workSchedule-image-4.png",
	"./yogaLevel-image-1.png": "./src/assets/image/template/yogaLevel-image-1.png",
	"./yogaLevel-image-2.png": "./src/assets/image/template/yogaLevel-image-2.png",
	"./yogaLevel-image-3.png": "./src/assets/image/template/yogaLevel-image-3.png",
	"./yogaLevel-image-4.png": "./src/assets/image/template/yogaLevel-image-4.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/image/template sync recursive ^\\.\\/.*$";